/* 
    custom helpers
*/

import { EngagementFlag } from '../constants/engagement-flag'
import { ExpenseSurvey } from 'src/app/shared/models/expense-survey';

const SURVEY_APP_URL = 'rcnsurvey.apps';


// simple copy for objects
export function copyObject(object: any): any {
    return object
        ? JSON.parse(JSON.stringify(object))
        : null;
}

// checking if string is not null or empty
export function stringNotEmpty(str: string): boolean {
    return str?.trim()?.length > 0;
}

export function arrayIsNullOrEmpty(arr: any[]): boolean {
    return !(arr?.length > 0);
}

// clearing input value before "contains" checking
export function clearValue(value: any): string {
    return value?.toString()?.trim()?.toLowerCase();
}

// checking if string contains substring
export function isContains(inputString: string, inputSubstring: string): boolean {
    if (inputString && inputSubstring) {
        return inputString.toUpperCase().includes(inputSubstring.toUpperCase())
    }
    else {
        return false;
    }
}

// checking if string contains substring with clearing
export function isPropertyContains(property: any, substring: string): boolean {
    const propertyValue = clearValue(property);
    const substringValue = clearValue(substring);
    return stringNotEmpty(propertyValue) &&
        stringNotEmpty(substringValue) &&
        isContains(propertyValue, substringValue);
}

export function idsStringToArray(inputString: string, separator: string): string[] {
    return inputString.split(separator)
        .map(value => value.trim());
}

export function getEngagementFlagById(engagementFlagId: number) {
    return (engagementFlagId >= 1 && engagementFlagId <= 3)
        ? EngagementFlag[engagementFlagId]
        : '';
}

export function getEngagementFlagStyleById(engagementFlagId: number) {
    return (engagementFlagId >= 1 && engagementFlagId <= 3)
        ? 'engagement-flag style' + engagementFlagId
        : '';
}

export function isRcnSurveyApplication(): boolean {
    const baseUrl = (new URL(window.location.href))?.hostname?.toLocaleLowerCase();
    return baseUrl?.includes(SURVEY_APP_URL);
}

export function encodeText(inputString: string): string {
    return window.btoa(unescape(encodeURIComponent(inputString === undefined ? '' : inputString)));
}

export function decodeText(inputString: string): string {
    return decodeURIComponent(escape(window.atob(inputString)));
}

export function getSurveyHeaderDetail(surveyId: number, isClientSme: boolean): ExpenseSurvey {
    let jsonData = isClientSme
        ? sessionStorage.getItem('smeexpensesurveyDetails') as string
        : sessionStorage.getItem('expensesurveyDetails') as string;
    if (stringNotEmpty(jsonData)) {
        return JSON.parse(jsonData) as ExpenseSurvey
    } else {
        let result = new ExpenseSurvey();
        result.surveyId = surveyId;
        return result;
    }
}

export function getDateForFileName() : string
{
    const template = (date: number) => (date < 10) ? "0" + date : "" + date;
    var currentDate = new Date();
    return currentDate.getFullYear() + ' ' +
        template(currentDate.getMonth() + 1) + ' ' +
        template(currentDate.getDate()) + ' ' +
        template(currentDate.getHours()) + ' ' +
        template(currentDate.getMinutes());
}